import { takeLatest, put, select } from 'redux-saga/effects';
import { forceReload as forceReloadUserList } from '~/components/containers/UserManagementContainer/reducer';
import callRequestSaga from '~/sagas/utils/request-saga';
import DeleteInviteConstants from '~/components/containers/DeleteInviteContainer/constants';
import UserManagementSubmenuConstants from '~/components/containers/UserManagementSubmenuContainer/constants';
import UserManagementAPI from '~/api/user-management-api';
import { redirectUser } from '~/ducks/router/actions';
import paths from '~/app/paths/paths';
import BaseException from '~/utils/fetch-wrapper/errors/BaseException';

export function* deleteInvitation({ inviteId }) {
  const response = yield* callRequestSaga(
    UserManagementAPI.deleteInvitation,
    {
      request: DeleteInviteConstants.DELETE_INVITATION_REQUEST,
      success: DeleteInviteConstants.DELETE_INVITATION_REQUEST_SUCCESS,
      failure: DeleteInviteConstants.DELETE_INVITATION_REQUEST_ERROR,
    },
    inviteId
  );

  if (response instanceof BaseException) {
    return;
  }

  yield put(forceReloadUserList());

  // Reload submenu
  yield put({
    type: UserManagementSubmenuConstants.GET_USER_MANAGEMENT_SUBMENU,
  });

  //If there only was one invite before deleting this invite, redirect user to list of all users
  const invites = yield select(
    ({ userManagement }) => userManagement.inviteList.invites
  );
  if (invites.size === 1) {
    yield put(
      redirectUser({
        path: paths.getPeopleOrUsers().getPath({ user_role: 'all' }),
      })
    );
  }
}

export function* deleteInvitationSaga() {
  // @ts-ignore
  yield takeLatest(DeleteInviteConstants.DELETE_INVITATION, deleteInvitation);
}

export default [deleteInvitationSaga];
